import { getTranslatedString } from 'helpers/i18n';
import React from 'react';

import { LeaseSummaryColumnContent } from '../common/LeaseStyles';

export default function LeaseAddenda({ leaseDetails }) {
  const leaseAddenda = leaseDetails?.draft_lease_data?.additional_addendums;

  if (!leaseAddenda?.length) {
    return (
      <LeaseSummaryColumnContent>
        {getTranslatedString(
          'landlordPortal.leaseCreatorV2.leaseSummaryPage.leaseAddenda.noAddendaIncluded'
        )}
      </LeaseSummaryColumnContent>
    );
  }

  const leaseAddendaList = leaseAddenda?.map((addenda) => (
    <LeaseSummaryColumnContent>{addenda.label}</LeaseSummaryColumnContent>
  ));

  return leaseAddendaList;
}
